<script setup lang="ts">
import { computed } from 'vue';
import { AppFormCard, AppTypography } from '@/core/components';

const props = withDefaults(
  defineProps<{
    title?: string | null;
    description?: string | null;
    value?: string | null;
    selected?: string | null;

    noBorder?: boolean;
    highlightSelected?: boolean;
  }>(),
  {
    title: null,
    description: null,
    value: '',
    selected: '',

    noBorder: false,
    highlightSelected: false,
  }
);

const isRadioChecked = computed(() => {
  return props.value === props.selected;
});
const radio = ref();
</script>

<template>
  <AppFormCard
    :class="{
      'card-option-item': title && description,
      'card-option-item--highlight': highlightSelected,
      'card-option-item-no-border': noBorder || (!title && description),
      'card-option-item-selected': title && description && isRadioChecked,
    }"
    no-gutter
  >
    <v-sheet class="d-flex" @click="radio.$el.querySelector('input').click()">
      <v-sheet class="me-auto text-left">
        <AppTypography v-if="title" type="headline-1" class="text-left pb-2">{{ title }}</AppTypography>
        <AppTypography 
          v-if="description" 
          type="body-1" 
          :class="{ 'text-left': true, 'pb-2': title && description }"
          style="line-height: 1.5; padding-top: 2px; padding-bottom: 2px;"
        >
          {{ description }}
        </AppTypography>
      </v-sheet>
      <v-sheet class="radio-item">
        <v-radio ref="radio" :value="value" density="compact" color="primary" />
      </v-sheet>
    </v-sheet>
  </AppFormCard>
</template>

<style lang="scss" scoped>
.v-sheet {
  cursor: pointer;
}

.card-option-item {
  border: 1px solid #e5e5e5;
  user-select: none;

  &--highlight.card-option-item-selected {
    border: 1px solid rgb(var(--v-theme-primary));
    outline: 1px solid rgb(var(--v-theme-primary));
  }
}

.card-option-item-no-border {
  border: none;
}

.radio-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
